<template>
  <v-layout row wrap>
    <v-flex xs4 class="pb-1 pr-1">
      <v-card class="max-height elevation-1">
        <v-card-text class="card-bg-1">
          <div class="caption grey--text text--darken-2">Time series</div>
          <div class="headline">
            {{numberWithCommas(dataSummary.timeSeries)}}
            <v-icon>mdi-clock</v-icon>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs4 class="px-1 pb-1">
      <v-card class="max-height elevation-1">
        <v-card-text class="card-bg-1">
          <div class="caption grey--text text--darken-2">From</div>
          <div class="headline">
            {{dataSummary.from}}
            <v-icon>event</v-icon>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs4 class="pb-1 pl-1">
      <v-card class="max-height elevation-1">
        <v-card-text class="card-bg-1">
          <div class="caption grey--text text--darken-2">To</div>
          <div class="headline">
            {{dataSummary.to}}
            <v-icon>event</v-icon>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 class="pt-1 px-0">
      <v-card class="max-height elevation-1">
        <v-card-text class="card-bg-1">
          <div class="caption grey--text text--darken-2">Available time series</div>
          <v-chip :selected="isActive(timeSeries)" :color="isActive(timeSeries) ? 'info lighten' : null" :dark="isActive(timeSeries)" v-for="(timeSeries, index) in dataSummary.availableTimeSeries/*.slice(0, 10)*/" class="clickable" :key="`timeSeries-${index}`" @click="setActive(timeSeries)" small>
            {{ timeSeries.displayName }}
          </v-chip>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import {
    addTimeSeriesDisplayNames,
    getDataTimeRange,
  } from '@/helpers/dataSources/continuousAquarius'

  import {
    numberWithCommas,
  } from '@/helpers/numbers'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  import {
    prettyDateFormat,
  } from '@/components/mixins/MomentUtil'

  import {
    stringSorter,
    objectSorter,
  } from '@/helpers/sorting'

  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')

  export default {
    data: () => ({
      selectedTimeSeries: null,
    }),
    computed: {
      ...monitoringFeatures.mapGetters(['currentFeatureDataSourceData']),
      continuousData() {
        return this.currentFeatureDataSourceData(SOURCE_TYPES.continuousAquarius)
      },
      datasets() {
        return this.continuousData && this.continuousData.details && this.continuousData.details.Datasets
      },
      dataSummary() {
        var summary = {}
        if (!this.datasets) return summary

        var datasets = this.datasets
        summary.timeSeries = datasets.length

        if (datasets.length) {
          summary.availableTimeSeries = addTimeSeriesDisplayNames(datasets).sort(objectSorter('displayName',
            stringSorter))

          var timeRange = getDataTimeRange(datasets)
          summary.from = timeRange[0].utcOffset('+0700').format(prettyDateFormat)
          summary.to = timeRange[1].utcOffset('+0700').format(prettyDateFormat)
        }

        return summary
      },
    },
    watch: {
      selectedTimeSeries(value) {
        this.$emit('update:timeSeries', value)
      },
      dataSummary: {
        immediate: true,
        handler(value) {
          if (!value || !value.availableTimeSeries) return

          let firstTimeSeries = value.availableTimeSeries[0]
          this.setActive(firstTimeSeries)
        },
      },
    },
    methods: {
      numberWithCommas,
      setActive(timeSeries) {
        this.selectedTimeSeries = timeSeries
      },
      isActive(timeSeries) {
        return this.selectedTimeSeries == timeSeries
      },
    },
  }
</script>